import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { Question } from 'types/question.types';
import { EventFeedbackSettings } from 'types/questions.types';

import { FeedbackQuestionsFragment, FeedbackSettingsFragment } from '../common';

export interface UpdateEventFeedbackTemplateInput {
  eventId: number;
  templateId: number;
}

export interface UpdateEventFeedbackTemplateResult {
  updateEventFeedbackTemplate: {
    ok: boolean;
    event: EventFeedbackSettings & {
      title: string;
      feedbackTemplateId: number;
      postQuestions: Question[];
    };
  };
}

const UpdateEventFeedbackTemplateMutation = gql`
  mutation updateEventFeedbackTemplate($input: UpdateEventFeedbackTemplateInput!) {
    updateEventFeedbackTemplate(input: $input) {
      ok
      event {
        title
        feedbackTemplateId
        ...FeedbackSettingsFragment
        postQuestions {
          ...FeedbackQuestionsFragment
        }
      }
    }
  }
  ${FeedbackQuestionsFragment}
  ${FeedbackSettingsFragment}
`;

export const updateEventFeedbackTemplate = (
  input: UpdateEventFeedbackTemplateInput
): Promise<UpdateEventFeedbackTemplateResult> => {
  return gqlClient.request<UpdateEventFeedbackTemplateResult>(UpdateEventFeedbackTemplateMutation, {
    input
  });
};
